import styled from "styled-components";

export const ManagerItemStyles = styled.div`
  display: flex;
  align-items: center;

  .fn {
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 15px;
    letter-spacing: 0.1px;
    color: ${({ theme }) => theme.colors.semantic.text.strong};
  }

  .ln {
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 15px;
    letter-spacing: 0.1px;
    color: ${({ theme }) => theme.colors.semantic.text.strong};
  }

  .perm {
    display: flex;
    align-items: center;
  }

  .ph {
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 15px;
    letter-spacing: 0.1px;
    color: ${({ theme }) => theme.colors.semantic.text.weak};
  }

  .em {
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 15px;
    letter-spacing: 0.1px;
    color: ${({ theme }) => theme.colors.semantic.text.weak};
  }

  .actions {
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing[8]};
  }

  .deleteButton:hover path {
    fill: ${({ theme }) => theme.colors.semantic.container.white};
  }
`;
